module.exports = __webpack_public_path__ + "img/sklyarenko.ec4fcd94.png";